// extracted by mini-css-extract-plugin
export var alert = "alert-module--alert--2c6de";
export var alert__black = "alert-module--alert__black--36c8d";
export var alert__bloodorange = "alert-module--alert__bloodorange--de192";
export var alert__chartruse = "alert-module--alert__chartruse--112c9";
export var alert__closed = "alert-module--alert__closed--eb7a5";
export var alert__cobalt = "alert-module--alert__cobalt--74a3c";
export var alert__emerald = "alert-module--alert__emerald--a510f";
export var alert__paper = "alert-module--alert__paper--bb5c1";
export var alert__pink = "alert-module--alert__pink--bc4a6";
export var alert__sky = "alert-module--alert__sky--53381";
export var alert__white = "alert-module--alert__white--e0f85";
export var close = "alert-module--close--b5d1f";
export var content = "alert-module--content--329e7";
export var link = "alert-module--link--7e4f0";
export var logo = "alert-module--logo--73190";
export var presented = "alert-module--presented--b0914";
export var spin = "alert-module--spin--178cd";
export var wrapper = "alert-module--wrapper--0ce11";